import React, { useState, useEffect } from "react";
import { getOS } from "./getOS";

const TextToSpeech = ({ text }) => {
  const [isPaused, setIsPaused] = useState(false);
  const [utterance, setUtterance] = useState(null);
  const [voice, setVoice] = useState(null);

  useEffect(() => {
    const synth = window.speechSynthesis;
    const u = new SpeechSynthesisUtterance(text);
    const voices = synth.getVoices();
    setUtterance(u);
    setVoice(voices[0]);
    return () => {
      synth.cancel();
    };
  }, [text]);

  const handlePlay = () => {
    const synth = window.speechSynthesis;
    if (isPaused) {
      synth.resume();
    } else {
      utterance.voice = voice;
      synth.speak(utterance);
    }

    setIsPaused(false);
  };

  const handlePause = () => {
    const synth = window.speechSynthesis;
    synth.pause();
    setIsPaused(true);
  };

  const handleStop = () => {
    const synth = window.speechSynthesis;
    synth.cancel();
    setIsPaused(false);
  };

  const handleVoiceChange = (event) => {
    const voices = window.speechSynthesis.getVoices();
    console.log("voices", voices);
    setVoice(voices.find((v) => v.name === event.target.value));
  };

  return (
    <div>
      <label>
        Voice:
        <select value={voice?.name} onChange={handleVoiceChange}>
          {window.speechSynthesis
            .getVoices().map((voice) => {
              return (
                <option key={voice.name} value={voice.name}>
                  {voice.name}
                </option>
              );
            })}
        </select>
      </label>
      <br />
      <button onClick={handlePlay}>{isPaused ? "Resume" : "Play"}</button>
      <br />
      <button onClick={handlePause}>Pause</button>
      <br />
      <button onClick={handleStop}>Stop</button>
    </div>
  );
};
export default TextToSpeech;

export const speakMessage = (
  text,
  setIsListening,
  isListening,
  recognition,
  selectedVoice = null,
  setIsSpeaking
) => {
  if ("speechSynthesis" in window || "webkitSpeechSynthesis" in window) {
    const speech = new SpeechSynthesisUtterance(text);
    // speech.lang = "en-IN"; // Set the language if needed

    speech.rate = 1; // Adjust the speech speed  
    speech.pitch = 1; // Adjust the pitch

    // Get available voices and choose one
    const voices = window.speechSynthesis.getVoices();
    if (voices.length > 0) {
      speech.voice = selectedVoice ? voices.find((v) => v.name === selectedVoice) || voices[0] : voices[0];
      if(getOS() === "iOS" &&  selectedVoice.name === "Rishi") {
        speech.pitch = 1.3;
      }
    }

    speech.onend = () => {
      if (text){
        console.log("Speech finished");
        if (isListening) {
          recognition.stop();
          setIsListening(false);
          setIsSpeaking(true);
        } else {
          recognition.start();
          setIsListening(true);
          setIsSpeaking(false);
        }
      } 
    };

    setIsSpeaking(true);
    window.speechSynthesis.speak(speech);
  } else {
    alert("Speech synthesis is not supported in this browser.");
  }
};

// Function to stop speech manually
export const stopSpeaking = (setIsSpeaking) => {
  if ("speechSynthesis" in window || "webkitSpeechSynthesis" in window) {
    window.speechSynthesis.cancel(); // Stops the speech immediately
    setIsSpeaking(false);
  }
};

// Function to get available voices
export const getAvailableVoices = () => {
  return new Promise((resolve) => {
    let voices = window.speechSynthesis.getVoices();
    if (voices.length > 0) {
      resolve(voices);
    } else {
      // If voices are not loaded, wait for the `voiceschanged` event
      window.speechSynthesis.onvoiceschanged = () => {
        voices = window.speechSynthesis.getVoices();
        resolve(voices);
      };
    }
  });
};
